import { ApiResponse } from '../../types';

export const aiOrchestrationService = {
  /**
   * Fetches AI agent status and metrics
   */
  async getStatus(): Promise<any> {
    try {
      const response = await fetch('/api/ai/status');
      if (!response.ok) throw new Error('Failed to fetch AI status');
      const result: ApiResponse = await response.json();
      return result.data;
    } catch (error) {
      console.error('Error fetching AI status:', error);
      // Fallback for development/demo
      return {
        activeAgents: 12,
        successRate: 94.5,
        totalExecutions: 1450,
        avgLatency: 350,
        recentTasks: [
          { id: '1', name: 'Code Generation', status: 'completed', duration: '1.2s' },
          { id: '2', name: 'Syntax Validation', status: 'completed', duration: '0.3s' },
          { id: '3', name: 'API Mapping', status: 'processing', duration: '2.5s' },
        ]
      };
    }
  },

  /**
   * Triggers an AI orchestration task
   */
  async orchestrate(task: { name: string; code: string; filename: string }): Promise<any> {
    try {
      const response = await fetch('/api/ai/orchestrate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(task)
      });
      if (!response.ok) throw new Error('Failed to orchestrate task');
      const result: ApiResponse = await response.json();
      return result.data;
    } catch (error) {
      console.error('Error orchestrating task:', error);
      throw error;
    }
  }
};
